import {
  FETCH_FAVOURITE_TEMPLATES_ERROR,
  FETCH_FAVOURITE_TEMPLATES_REQUEST,
  FETCH_FAVOURITE_TEMPLATES_SUCCESS,
  ORDER_FAVOURITE_TEMPLATE_SUCCESS,
  TOGGLE_FAVOURITE_TEMPLATE_ERROR,
  TOGGLE_FAVOURITE_TEMPLATE_LOCAL,
  TOGGLE_FAVOURITE_TEMPLATE_REQUEST,
  TOGGLE_FAVOURITE_TEMPLATE_SUCCESS,
} from "./actionTypes";
import {
  FavouriteTemplate,
  FetchFavouriteTemplatesError,
  FetchFavouriteTemplatesRequest,
  FetchFavouriteTemplatesSuccess,
  OrderFavouriteTemplateSuccess,
  ToggleFavouriteTemplateError,
  ToggleFavouriteTemplateLocal,
  ToggleFavouriteTemplateRequest,
  ToggleFavouriteTemplateSuccess,
} from "./types";
import { TemplateId } from "../../globalTypes";
import { AError } from "../../requests/types";

/* ********** FETCH ********** */
export const fetchFavouriteTemplatesRequest =
  (): FetchFavouriteTemplatesRequest => ({
    type: FETCH_FAVOURITE_TEMPLATES_REQUEST,
  });

export const fetchFavouriteTemplatesSuccess = (
  favouriteTemplates: FavouriteTemplate[]
): FetchFavouriteTemplatesSuccess => ({
  type: FETCH_FAVOURITE_TEMPLATES_SUCCESS,
  payload: favouriteTemplates,
});

export const fetchFavouriteTemplatesError = (
  error?: AError
): FetchFavouriteTemplatesError => ({
  type: FETCH_FAVOURITE_TEMPLATES_ERROR,
  payload: error,
});

/* ********** TOGGLE ********** */
export const toggleFavouriteTemplateLocal = (
  id: TemplateId
): ToggleFavouriteTemplateLocal => ({
  type: TOGGLE_FAVOURITE_TEMPLATE_LOCAL,
  payload: id,
});

export const toggleFavouriteTemplateRequest = (
  id: TemplateId
): ToggleFavouriteTemplateRequest => ({
  type: TOGGLE_FAVOURITE_TEMPLATE_REQUEST,
});

export const toggleFavouriteTemplateSuccess =
  (): ToggleFavouriteTemplateSuccess => ({
    type: TOGGLE_FAVOURITE_TEMPLATE_SUCCESS,
  });

export const toggleFavouriteTemplateError = (
  error: AError
): ToggleFavouriteTemplateError => ({
  type: TOGGLE_FAVOURITE_TEMPLATE_ERROR,
  payload: error,
});

export const orderFavouriteTemplateSuccess =
  (): OrderFavouriteTemplateSuccess => ({
    type: ORDER_FAVOURITE_TEMPLATE_SUCCESS,
  });
